import React, { useState } from 'react';
import Chatbot from "./Chatbot";

const Footer = () => {
    const [, setFilterCriteria] = useState({});

    // Function to handle filter criteria changes
    const handleFilterCriteriaChange = (newCriteria) => {
        setFilterCriteria(newCriteria);
    };

    return (
        <div className="footer">
            <div className={"copyright"}>
                &copy;Copyright 2026, NYX NoCode, All Rights Reserved
            </div>
            <div>
                <Chatbot setFilterCriteria={handleFilterCriteriaChange} />
            </div>
        </div>
    );
};

export default Footer;
